import React from 'react';
import { toKey, types } from '@tmap/mmm-core/entityKey';
import ContentPage from '../../components/contentPage';
import getEnrichedContent from '../../lib/content/getEnrichedContent';
import getRelatedContent from '../../lib/content/getRelatedContent';
import setCacheHeaders from '../../lib/setCacheHeaders';

function ArticlesPage(props) {
  const {
    article,
    contentSettings,
    relatedArticles,
  } = props;
  const canonicalUrl = `${process.env.NEXT_PUBLIC_CANONICAL_DOMAIN}/articles/${article.slug.current}`;

  return (
    <ContentPage
      article={article}
      contentSettings={contentSettings}
      relatedArticles={relatedArticles}
      canonicalUrl={canonicalUrl}
    />
  );
}

export const getServerSideProps = async (context) => {
  const { slug = '' } = context.query;

  const result = await getEnrichedContent('articles', slug);
  if (!result || !result.article) {
    return { notFound: true };
  }

  const relatedArticles = await getRelatedContent(result.article);

  const analyticsProps = {
    pageName: 'article',
    entityKey: toKey(types.ARTICLE, result.article._id),
  };
  setCacheHeaders(context.res, 300, 3600);
  return {
    props: {
      analyticsProps,
      ...result,
      relatedArticles,
    },
  };
};

export default ArticlesPage;
